import { render } from "./PrintedCTA.vue?vue&type=template&id=0936b792&scoped=true"
import script from "./PrintedCTA.vue?vue&type=script&lang=js"
export * from "./PrintedCTA.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0936b792"

export default script